/*
 * Copyright (c) 2019. Legalbird eine Marke der R&S Internet Jewels GmbH
 */
import React from "react";
import Grid from "@mui/material/Grid";
import { formValue } from "../../../services/formServiceFunctions";
import MenuItem from "@mui/material/MenuItem";
import useForm from "../../../hooks/useForm";
import { requiredFieldDefault } from "../../../services/validationRules";
import ValidatorSelect from "../../Validator/ValidatorSelect";
import ValidatorForm from "../../Validator/ValidatorForm";
import SubmitButton from "../../Button/SubmitButton";
import _ from "lodash";
import ValidatorNumberField from "../../Validator/ValidatorNumberField";
import { Box } from "@mui/material";
import { processCostSupportStyle } from "../processCostSupportStyle";
import { ProcessCostSupportFormProps } from "../../../types/ProcessCostSupport";

const MobilityCostDeduction = ({ pcs, onSubmit, isLoading }: ProcessCostSupportFormProps) => {
  const initialValues = {
    hasMobilityCostDeduction: pcs.hasMobilityCostDeduction,
    mobilityCostUnit: pcs.mobilityCostUnit,
    mobilityCostAmount: pcs.mobilityCostAmount,
  };

  const { values, errors, handleChange, handleSubmit, handleBlur, registerValidators, touchedValues } = useForm({
    initialValues,
    onSubmit,
    identifier: pcs,
  });

  return (
    <>
      <Box sx={processCostSupportStyle.sectionHeadline}>Fahrtkosten</Box>
      <ValidatorForm onSubmit={handleSubmit}>
        <Grid container sx={processCostSupportStyle.grid}>
          <Grid sx={processCostSupportStyle.question} size={12}>
            Haben Sie Fahrtkosten für den Weg zur Arbeit?
          </Grid>
          <Grid
            size={{
              xs: 12,
              md: 6,
              lg: 4,
            }}
          >
            <ValidatorSelect
              label={"Fahrtkosten"}
              name={"hasMobilityCostDeduction"}
              value={formValue(values, "hasMobilityCostDeduction")}
              onChange={handleChange}
              onBlur={handleBlur}
              registerValidators={registerValidators}
              dependentValidationFields={["mobilityCostUnit", "mobilityCostAmount"]}
            >
              <MenuItem value={"no"}>Nein</MenuItem>
              <MenuItem value={"yes"}>Ja</MenuItem>
            </ValidatorSelect>
          </Grid>
          <Grid
            size={{
              xs: 12,
              md: 6,
              lg: 4,
            }}
          >
            <ValidatorSelect
              label={"Verkehrsmittel"}
              onBlur={handleBlur}
              error={!!errors["mobilityCostUnit"]}
              helperText={errors["mobilityCostUnit"]}
              fullWidth
              registerValidators={registerValidators}
              validators={formValue(values, "hasMobilityCostDeduction") === "yes" ? requiredFieldDefault : []}
              value={formValue(values, "mobilityCostUnit")}
              onChange={handleChange}
              name={`mobilityCostUnit`}
              inputProps={{
                name: `mobilityCostUnit`,
                id: "mobilityCostUnit",
              }}
              MenuProps={{
                slotProps: {
                  paper: {
                    sx: { maxHeight: 200 },
                  },
                },
              }}
              disabled={formValue(values, "hasMobilityCostDeduction") !== "yes"}
            >
              <MenuItem value={"km"}>Mit dem eigenen Auto</MenuItem>
              <MenuItem value={"€"}>Mit öffentlichen Verkehrsmitteln</MenuItem>
            </ValidatorSelect>
          </Grid>
          <Grid
            size={{
              xs: 12,
              md: 6,
              lg: 4,
            }}
          >
            <ValidatorNumberField
              fieldType={values.mobilityCostUnit === "km" ? "kilometers" : "money"}
              numberType={"float"}
              fullWidth={true}
              id="mobilityCostAmount"
              name="mobilityCostAmount"
              label={values.mobilityCostUnit === "km" ? "km pro Strecke" : "Mtl. Kosten"}
              onBlur={handleBlur}
              isHighlighted={formValue(values, "hasMobilityCostDeduction") === "yes"}
              registerValidators={registerValidators}
              error={!!errors["mobilityCostAmount"]}
              helperText={errors["mobilityCostAmount"]}
              margin="normal"
              value={formValue(values, "mobilityCostAmount")}
              onChange={handleChange}
              disabled={formValue(values, "hasMobilityCostDeduction") !== "yes"}
            />
          </Grid>
          <Grid size={12}>
            <SubmitButton
              error={_.keys(errors).length > 0}
              isLoading={isLoading}
              disabled={_.keys(touchedValues).length === 0}
              variant={"contained"}
              type={"submit"}
            >
              Änderungen speichern
            </SubmitButton>
          </Grid>
        </Grid>
      </ValidatorForm>
    </>
  );
};

export default MobilityCostDeduction;
